import React, { ReactNode } from 'react';

type SpinButtonProps = {
  [x in 'onTouchStart' | 'onMouseDown']?: (event: any) => void;
} & {
  onMouseUp: () => void;
  onMouseLeave: () => void;
  onTouchEnd: () => void;
  disabled: boolean;
  'aria-disabled': boolean;
};

interface Props extends SpinButtonProps {
  children?: ReactNode;
}

export function NumericInputSpinButton({ children, ...props }: Props) {
  const colorClass = props.disabled ? 'text-grey-600' : 'text-grey-800';

  return (
    <button
      className={`flex items-center justify-center h-full p-0 bg-transparent border-0 appearance-none cursor-pointer ${colorClass}`}
      type="button"
      tabIndex={-1}
      aria-live="polite"
      aria-atomic="true"
      {...props}
    >
      {children}
    </button>
  );
}

NumericInputSpinButton.Up = function Up() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M8.47 11.47a.75.75 0 01.976-.073l.084.073 3 3a.75.75 0 01-.427 1.273L12 15.75H6a.75.75 0 01-.598-1.203l.068-.077 3-3z"
      />
    </svg>
  );
};

NumericInputSpinButton.Down = function Down() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M12 2.25a.75.75 0 01.598 1.203l-.068.077-3 3a.75.75 0 01-.976.073L8.47 6.53l-3-3a.75.75 0 01.427-1.273L6 2.25h6z"
      />
    </svg>
  );
};
